import { useEffect } from "react";
import { api, track } from "@/lib/api";
import { useSettings } from "@/context/SettingsContext";
import { Button } from "@/components/ui/button";
import SEO from "@/components/SEO";
import { Star } from "lucide-react";

export default function Recensione() {
  const { settings } = useSettings();
  useEffect(() => { track("page_view", "recensione"); }, []);

  return (
    <div>
      <SEO title="La tua esperienza" description="Racconta la tua esperienza al Ristorante Masetti di Zola Predosa." />
      <div className="min-h-[70vh] flex items-center justify-center bg-cream-dark py-16">
        <div className="max-w-lg mx-auto px-6 text-center">
          <div className="flex justify-center gap-1 mb-4">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-6 h-6 fill-brass text-brass" />)}
          </div>
          <h1 className="font-serif text-3xl sm:text-4xl text-bordeaux">Com'è stata la tua esperienza da Masetti?</h1>
          <p className="font-accent italic text-xl text-oak/75 mt-4">Se ti sei trovato bene, ci fa piacere conoscere la tua esperienza.</p>
          {settings.google_review_url ? (
            <a href={settings.google_review_url} target="_blank" rel="noreferrer" onClick={() => track("review_click")}>
              <Button className="bg-bordeaux hover:bg-bordeaux-dark text-cream rounded-full px-8 h-12 mt-8" data-testid="review-btn">Lascia una recensione su Google</Button>
            </a>
          ) : (
            <div className="mt-8">
              <Button disabled className="bg-bordeaux/50 text-cream rounded-full px-8 h-12" data-testid="review-btn-disabled">Lascia una recensione su Google</Button>
              <p className="text-xs text-oak/50 mt-3">Il link alla recensione sarà attivo a breve.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
